// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stock_container__dcDUg {
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.Stock_container__dcDUg .Stock_header__p\\+Q1y {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Stock_container__dcDUg .Stock_header__p\\+Q1y .Stock_titleContainer__nVRIW {
  animation: Stock_toright__53J9R 0.3s;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Stock_container__dcDUg .Stock_header__p\\+Q1y .Stock_titleContainer__nVRIW h4 {
  font-size: 1.6rem;
  font-family: Roboto, sans-serif;
  font-weight: 300;
}

.Stock_container__dcDUg .Stock_loader__f4jk3 {
  animation: Stock_init__mimLv 0.5s both;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
}

.Stock_container__dcDUg .Stock_data__jxq1g {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  min-height: 300px;
}

/*---Información---*/
.Stock_container__dcDUg .Stock_data__jxq1g .Stock_tableContainer__dMpu6 {
  animation: Stock_toleft__szEnH 0.3s;
  border-radius: 5px;
  max-height: 80vh;
  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);
}

.Stock_container__dcDUg .Stock_data__jxq1g .Stock_tableContainer__dMpu6 .Stock_tableTitle__vvBBR {
  font-size: 0.9rem;
  font-weight: 500;
}

.Stock_container__dcDUg .Stock_filters__qO\\+8V {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.Stock_container__dcDUg .Stock_filters__qO\\+8V .Stock_item__xtNra {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 30px;
  margin-right: 10px;
}

.Stock_container__dcDUg .Stock_filters__qO\\+8V h4 {
  font-size: 1.3rem;
  font-weight: 300;
  margin-top: 0;
  animation: Stock_toleft__szEnH 0.5s both;
}

.Stock_container__dcDUg .Stock_filters__qO\\+8V .Stock_loaderGames__LeXFJ {
  animation: Stock_init__mimLv 0.5s 0.2s both;
}

.Stock_container__dcDUg .Stock_filters__qO\\+8V .Stock_init1__83rws {
  animation: Stock_init__mimLv 0.5s 0.2s both;
}
.Stock_container__dcDUg .Stock_filters__qO\\+8V .Stock_init2__MjKjs {
  animation: Stock_init__mimLv 0.5s 0.4s both;
}

.Stock_container__dcDUg .Stock_options__dqZJM {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 10px;
}

.Stock_container__dcDUg .Stock_options__dqZJM p {
  margin: 0 0 0 10px;
  text-transform: capitalize;
  font-weight: 300;
}

@keyframes Stock_init__mimLv {
  0% {
    opacity: 0;
    transform: translateY(50px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes Stock_toright__53J9R {
  0% {
    opacity: 0;
    transform: translateX(-100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes Stock_toleft__szEnH {
  0% {
    opacity: 0;
    transform: translateX(100px);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@media print {
  @page {
    size: landscape;
    margin: 20px 0 0;
    quotes: none;
    visibility: visible;
  }

  .Stock_container__dcDUg .Stock_header__p\\+Q1y {
    display: none !important;
  }

  .Stock_container__dcDUg .Stock_filters__qO\\+8V {
    display: none !important;
  }

  .Stock_container__dcDUg .Stock_data__jxq1g {
    margin: 0;
    min-width: 99%;
  }

  .Stock_container__dcDUg .Stock_data__jxq1g .Stock_tableContainer__dMpu6 {
    margin: 0;
    box-shadow: none;
    border-radius: 0;
  }

  .Stock_tableTitle__vvBBR {
    color: black !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Pages/Stock/Stock.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oCAAuB;EACvB,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,sCAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,mCAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,wCAA2B;AAC7B;;AAEA;EACE,2CAA8B;AAChC;;AAEA;EACE,2CAA8B;AAChC;AACA;EACE,2CAA8B;AAChC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,6BAA6B;EAC/B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,SAAS;IACT,cAAc;EAChB;;EAEA;IACE,SAAS;IACT,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n}\n\n.container .header {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer {\n  animation: toright 0.3s;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.container .header .titleContainer h4 {\n  font-size: 1.6rem;\n  font-family: Roboto, sans-serif;\n  font-weight: 300;\n}\n\n.container .loader {\n  animation: init 0.5s both;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 300px;\n}\n\n.container .data {\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  min-height: 300px;\n}\n\n/*---Información---*/\n.container .data .tableContainer {\n  animation: toleft 0.3s;\n  border-radius: 5px;\n  max-height: 80vh;\n  box-shadow: 0 0 15px -3px rgba(0, 0, 0, 0.268);\n}\n\n.container .data .tableContainer .tableTitle {\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.container .filters {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.container .filters .item {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 30px;\n  margin-right: 10px;\n}\n\n.container .filters h4 {\n  font-size: 1.3rem;\n  font-weight: 300;\n  margin-top: 0;\n  animation: toleft 0.5s both;\n}\n\n.container .filters .loaderGames {\n  animation: init 0.5s 0.2s both;\n}\n\n.container .filters .init1 {\n  animation: init 0.5s 0.2s both;\n}\n.container .filters .init2 {\n  animation: init 0.5s 0.4s both;\n}\n\n.container .options {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n.container .options p {\n  margin: 0 0 0 10px;\n  text-transform: capitalize;\n  font-weight: 300;\n}\n\n@keyframes init {\n  0% {\n    opacity: 0;\n    transform: translateY(50px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes toright {\n  0% {\n    opacity: 0;\n    transform: translateX(-100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes toleft {\n  0% {\n    opacity: 0;\n    transform: translateX(100px);\n  }\n  100% {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@media print {\n  @page {\n    size: landscape;\n    margin: 20px 0 0;\n    quotes: none;\n    visibility: visible;\n  }\n\n  .container .header {\n    display: none !important;\n  }\n\n  .container .filters {\n    display: none !important;\n  }\n\n  .container .data {\n    margin: 0;\n    min-width: 99%;\n  }\n\n  .container .data .tableContainer {\n    margin: 0;\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  .tableTitle {\n    color: black !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Stock_container__dcDUg`,
	"header": `Stock_header__p+Q1y`,
	"titleContainer": `Stock_titleContainer__nVRIW`,
	"toright": `Stock_toright__53J9R`,
	"loader": `Stock_loader__f4jk3`,
	"init": `Stock_init__mimLv`,
	"data": `Stock_data__jxq1g`,
	"tableContainer": `Stock_tableContainer__dMpu6`,
	"toleft": `Stock_toleft__szEnH`,
	"tableTitle": `Stock_tableTitle__vvBBR`,
	"filters": `Stock_filters__qO+8V`,
	"item": `Stock_item__xtNra`,
	"loaderGames": `Stock_loaderGames__LeXFJ`,
	"init1": `Stock_init1__83rws`,
	"init2": `Stock_init2__MjKjs`,
	"options": `Stock_options__dqZJM`
};
export default ___CSS_LOADER_EXPORT___;
